'use client';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ParamsObject } from '@/frontastic/tastics/types';
import useSiteTranslation from '@/providers/i18n/hooks/useSiteTranslation';
import ConfirmationIdSection from './form-sections/confirmationId';
import OrderIdSection from './form-sections/orderId';
import OrderQueues from './form-sections/orderQueues';
import OrderSearchRadioGroup from './form-sections/radioGroup';
import { FORM_FIELD_SPECS, SEARCH_ORDER_PAGE_PATH, PAGE_TEXTS_KEYS } from '../../../../../../constants/constant';
import { Card, CardHeader, CardTitle } from '../../../ui/card';
import { TabsContent } from '../../../ui/tabs';
import { ORDER_SEARCH_TYPES } from '../../constants';
import { CustomerAndOrderSearchPropsTypes } from '../../types';
import ZipLNameFNameSection from '../common/form-sections/zipCode';
const Index = ({
  setSelectedSearchType,
  selectedSearchType,
  searchParams,
  setSearchParams,
  handleSearch,
}: CustomerAndOrderSearchPropsTypes) => {
  const Texts = useSiteTranslation(PAGE_TEXTS_KEYS?.customerAndOrderSearch);
  const {
    register,
    handleSubmit,
    reset: resetOrderIdForm,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
  });
  const {
    register: registerConfirmationId,
    handleSubmit: handleSubmitConfirmationId,
    reset: resetConfirmationIdForm,
    formState: { errors: confirmationIdErrors },
  } = useForm({
    mode: 'onBlur',
  });
  const onSubmit = (params: ParamsObject) => {
    handleSearch(params);
  };

  const [formWrapperKey, setFormWrapperKey] = useState({
    [FORM_FIELD_SPECS?.orderId?.id]: `key_${selectedSearchType}_${FORM_FIELD_SPECS?.orderId?.id}`,
    [FORM_FIELD_SPECS?.confirmationId?.id]: `key_${selectedSearchType}_${FORM_FIELD_SPECS?.confirmationId?.id}`,
  });

  return (
    <TabsContent value={SEARCH_ORDER_PAGE_PATH}>
      <Card>
        <CardHeader>
          <CardTitle className="mb-4 flex justify-between text-lg font-bold">
            <span className="">{Texts?.orderSearchHeading}</span>
          </CardTitle>
          <OrderSearchRadioGroup
            selectedSearchType={selectedSearchType}
            setSearchParams={setSearchParams}
            ORDER_SEARCH_TYPES={ORDER_SEARCH_TYPES}
            setSelectedSearchType={setSelectedSearchType}
          />
        </CardHeader>
        <section className="relative flex pb-10">
          <section className="lg:w-1/2 lg:pr-16">
            <form
              onSubmit={handleSubmit(onSubmit)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleSubmit(onSubmit)();
                }
              }}
            >
              {selectedSearchType === ORDER_SEARCH_TYPES?.orderId && (
                <OrderIdSection
                  setSearchParams={setSearchParams}
                  formWrapperKey={formWrapperKey}
                  setFormWrapperKey={setFormWrapperKey}
                  resetFormOnInteraction={resetConfirmationIdForm}
                  selectedSearchType={selectedSearchType}
                  FORM_FIELD_SPECS={FORM_FIELD_SPECS}
                  searchParams={searchParams}
                  errors={errors}
                  register={register}
                />
              )}
              {selectedSearchType === ORDER_SEARCH_TYPES?.recipient && (
                <ZipLNameFNameSection
                  FORM_FIELD_SPECS={FORM_FIELD_SPECS}
                  selectedSearchType={selectedSearchType}
                  searchParams={searchParams}
                  errors={errors}
                  register={register}
                />
              )}
              {selectedSearchType === ORDER_SEARCH_TYPES?.orderQueues && (
                <OrderQueues
                  FORM_FIELD_SPECS={FORM_FIELD_SPECS}
                  selectedSearchType={selectedSearchType}
                  searchParams={searchParams}
                  errors={errors}
                  register={register}
                />
              )}
            </form>
          </section>
          {selectedSearchType === ORDER_SEARCH_TYPES?.orderId && (
            <ConfirmationIdSection
              setSearchParams={setSearchParams}
              formWrapperKey={formWrapperKey}
              setFormWrapperKey={setFormWrapperKey}
              resetFormOnInteraction={resetOrderIdForm}
              selectedSearchType={selectedSearchType}
              FORM_FIELD_SPECS={FORM_FIELD_SPECS}
              handleSubmitConfirmationId={handleSubmitConfirmationId}
              onSubmit={onSubmit}
              registerConfirmationId={registerConfirmationId}
              confirmationIdErrors={confirmationIdErrors}
              searchParams={searchParams}
            />
          )}
        </section>
      </Card>
    </TabsContent>
  );
};

export default Index;
